var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicationsSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135 -119) translate(99 106) translate(36 13) translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.058,
    d: "M3.833 5.699L0.031 5.699 0.031 0 5.639 0 5.639 4.161"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.058,
    d: "M0.648 14.965L0.017 14.965 0.017 9.295 5.653 9.295 5.653 11.8",
    transform: "rotate(-90 2.835 12.13)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.642,
    cy: 9.232,
    strokeWidth: 1.154,
    rx: 4.04,
    ry: 4.06
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.058,
    d: "M12.684 5.685L9.347 5.685 9.347 0.014 14.983 0.014 14.983 1.653",
    transform: "rotate(90 12.165 2.85)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.154,
    d: "M14.393 14.877L11.512 12.13"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsSmall);
export default __webpack_public_path__ + "static/media/applications-small.57a08b7d381a81a9da52d192574bf4d3.svg";
export { ForwardRef as ReactComponent };